"use strict";
exports.__esModule = true;
exports.getPaymentInformation = void 0;
var money_1 = require("./money");
var getFirstAndSecondPayment = function (installments, isEnabledForSLC) {
    if (isEnabledForSLC) {
        return installments;
    }
    var firstPayment = installments.find(function (installment) {
        return installment.day === 0;
    });
    var secondPayment = installments.find(function (installment) {
        return installment.day !== 0;
    });
    return [firstPayment, secondPayment];
};
var getPaymentInformation = function (fees, isEnabledForSLC) {
    var installments = fees.installments, subscriptionFee = fees.subscriptionFee, processingFeePercentage = fees.processingFeePercentage;
    var _a = getFirstAndSecondPayment(installments, isEnabledForSLC), firstPayment = _a[0], secondPayment = _a[1];
    var firstPaymentBaseAmount = (firstPayment === null || firstPayment === void 0 ? void 0 : firstPayment.baseAmount) || 0;
    var secondPaymentBaseAmount = (secondPayment === null || secondPayment === void 0 ? void 0 : secondPayment.baseAmount) || 0;
    var firstPaymentAmount = isEnabledForSLC ? firstPayment === null || firstPayment === void 0 ? void 0 : firstPayment.totalAmount : firstPaymentBaseAmount;
    var secondPaymentAmount = isEnabledForSLC ? secondPayment === null || secondPayment === void 0 ? void 0 : secondPayment.totalAmount : secondPaymentBaseAmount;
    var rentAmount = firstPaymentBaseAmount + secondPaymentBaseAmount;
    var firstPaymentAmountFormatted = (0, money_1.toFormattedDollars)(firstPaymentAmount);
    var subscriptionFeeFormatted = (0, money_1.toFormattedDollars)(subscriptionFee);
    var secondPaymentAmountFormatted = (0, money_1.toFormattedDollars)(secondPaymentAmount);
    var rentAmountFormatted = (0, money_1.toFormattedDollars)(rentAmount);
    return {
        firstPaymentBaseAmount: firstPaymentBaseAmount,
        secondPaymentBaseAmount: secondPaymentBaseAmount,
        subscriptionFeeFormatted: subscriptionFeeFormatted,
        firstPaymentAmountFormatted: firstPaymentAmountFormatted,
        secondPaymentAmountFormatted: secondPaymentAmountFormatted,
        rentAmountFormatted: rentAmountFormatted,
        processingFeePercentage: processingFeePercentage
    };
};
exports.getPaymentInformation = getPaymentInformation;
